import {Component, OnDestroy, TemplateRef} from '@angular/core';
import {ICellRendererAngularComp} from 'ag-grid-angular';
import {GridApi, IAfterGuiAttachedParams, ICellRendererParams} from 'ag-grid-community';
import {BsModalRef, BsModalService, ModalOptions} from 'ngx-bootstrap/modal';
import {FormService} from '../../../../services/form.service';
import {faPencilAlt} from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'lib-korrektur-button-cell-component',
  templateUrl: './korrektur-button-cell-component.component.html',
  styleUrls: ['./korrektur-button-cell-component.component.scss']
})
export class KorrekturButtonCellComponentComponent implements ICellRendererAngularComp, OnDestroy {
  public faPencilAlt = faPencilAlt;
  public params: ICellRendererParams;
  public gridApi: GridApi;
  modalRef: BsModalRef;
  public dienste: string;


  constructor(private modalService: BsModalService, private formService: FormService) {
    this.formService.dienste$.subscribe((dienste: string) => {
      this.dienste = dienste;
    });
  }

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.gridApi = params.api;
  }

  ngOnDestroy(): void {
  }

  openModal(template: TemplateRef<any>): void {
    const config: ModalOptions = {
      backdrop: 'static',
      keyboard: false,
      animated: true,
      ignoreBackdropClick: true,
    };
    this.modalRef = this.modalService.show(template, config);
  }

  closeModal(event: any) {
    this.modalRef.hide();
  }

  refresh(): boolean {
    return true;
  }

  afterGuiAttached?(params?: IAfterGuiAttachedParams): void {
  }

  public close() {
    this.modalRef.hide();
  }

}
